export default {
  firstname: '',
  lastname: '',
  role: '',
  store: '',
  username: '',
  password: ''
};
